import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import "../assets/css/monthpicker/month-picker.css";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import { List } from 'react-virtualized';
import ModalD from "react-awesome-modal";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthOptions = [];
var monthOptions_task = [];
for(var i=0; i<=23; i++){
    let date2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    //console.log("currDate"); console.log(date2);
    let monthd = date2.setMonth(date2.getMonth() -i);
    date2 = date2.toDateString();
    date2 = new Date(date2);
    let month2 = getMonth(date2);
    let year2 = date2.getFullYear();
    let monthName2 = monthNames[date2.getMonth()];
    var isDisable = true;
    if(month2 == '06' || month2 == '07'){
        isDisable = false;
    }
    monthOptions.push({ value: month2+'_'+year2, label: monthName2+' '+year2});
    if(i>=12) {
        monthOptions_task.push({ value: month2+year2, label: monthName2+' '+year2})
    }

}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var tod1 = moment(todayDate).format('MM/DD/YYYY');
var yest1 = moment(yesterday).format('MM/DD/YYYY');
var todShow1 = moment(todayDate).format('D MMM YYYY');
var yestShow1 = moment(yesterday).format('D MMM YYYY');
var todSend1 = moment(todayDate).format('YYYY-MM-DD');
var yestSend1 = moment(yesterday).format('YYYY-MM-DD');


var date_limit = moment(todayDate).format('MM/DD/YYYY');
class AuditLog extends Component{
    constructor(props) {
        super(props);
        this.state = {
            feq_name_list:[],
            month_year:monthOptions[0+12].value,
            frequency_id:2,
            task_data:[],
            newRiseModel: false,
            newIssueModel: false,
            newErrorModel: false,
            loading:true,
            merchantList:[{value:'', label: 'All'}],
            chainList:[{value:'', label: 'All'}],
            merchantID:[],
            chainID:[],
            storeID:[],
            storeList:[{value:'', label: 'All'}],
            mvalue: {year: new Date().getFullYear(), month: 11},
            month_year_task:monthOptions_task[0].value,
            arg_type: 'Merchant',
            acq_bank_list:[{value:'', label: 'All'}],
            acq_bank_id:[],
            feq_id:'',
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            dateTo1:tod,
            dateToShow1:todShow,
            todSend1:todSend,
            yestSend1:yestSend,
            datefrom1:yest,
            datefromShow1:yestShow,
            task_identifier: '',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds: [],
            force_run: 0,
            error_data: [],
            etype: '',
            statusList:[{value:'', label: 'All'},{value:'success', label: 'Success'},{value:'failed', label: 'Failed'},{value:'running', label: 'Running'},{value:'pending', label: 'Pending'},{value:'stopped', label: 'Stopped'}],
            statusValue:{value:'', label: 'All'},
            selected_status:''
        };
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);
        this.setState({email:decoded.email,userSubGroup:decoded.userSubGroup,userGroup:decoded.userGroup});
        this.get_frequency();
        this.get_all_acq_bank();
        this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,decoded.userSubGroup,decoded.userGroup);
        this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,decoded.userSubGroup,decoded.userGroup);
        this._getAllMerchants();
        this._get_issuing_banks();
        // this.interval = setInterval(() => {
        //     this.get_process_log(this.state.frequency_id, this.state.month_year);
        // }, 30000);
    }
    get_all_acq_bank() {
        axios.get(config.get('API_URL')+'/invoice/all_acq_banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(response.data.data != null) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acq_bank_list.push({value: response.data.data[key], label: key})
                });
            }
        });
    }

    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) { // alert(value); alert(text);
        this.setState({
            mvalue: {year: value, month: text}
        });
        //this.refs.pickAMonth.hide()
        this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            response.data.map((merchant,index) => {
                this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
        });
    }
    changeMerchant(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        let midArray = [];
        midArray.push(value)
        this.setState({
            merchantID:midArray,
            chainID: [],
            merchantValue:optionSelected,
            chainValue:null
        });
        axios.post(config.get('API_URL')+'/invoice/chains_by_merchant_code/',{
                code: value,
             },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [{value:'', label: 'All'}];
            this.setState({chainID: []});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    changeChain(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        let cidArray = [];
        cidArray.push(value)
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected
        });
        axios.post(config.get('API_URL')+'/invoice/store_by_chain_code/', {
                code: value,

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
        }).then(response => { //console.log(response);
            let storeList = [{value:'', label: 'All'}];
            this.setState({storeID: []});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        let sidArray = [];
        sidArray.push(value)
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
    }
    _get_issuing_banks() {
        this.setState({
            acq_loading: true
        })
        axios.get(config.get('API_URL')+'/reports/get-issuing-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuing_bank_name, label: issuBank.issuing_bank_name})
                });
            }
            this.setState({
                acq_loading: false
            })
        });

    }
    change_issuer(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            issuerBankIds: value,
            issuerBankValue:optionSelected
        });
    }

    toggleNewStartModel(key,id, e) {
        this.setState({
            newRiseModel: !this.state.newRiseModel,
            feq_id:id,
            task_identifier: key
        })
    }
    toggleNewIssueModel(e, issue) {
        this.setState({
            newIssueModel: !this.state.newIssueModel,
            issue: issue
        })
    }

    toggleNewErrorModel(data) {
        this.setState({
            newErrorModel: true,
            error_data: data
        })
    }

    closeModal() {
        this.setState({
            newErrorModel: false
        });
    }

    closeModalAndRun() {
        this.handleClickRerunTask(1, 'manual');
        this.setState({
            newErrorModel: false
        });
    }
    get_task_schedule(frequency_id, from, to,status,userSubGroup,userGroup) {

        this.setState({
            loading: true
        });
        if ($.fn.DataTable.isDataTable('#TaskTable')) {
            $('#TaskTable').DataTable().destroy();
        }
        // const fields = month.split('_');
        // const monthval = fields[0];
        // const yearval = fields[1];
         axios.get(config.get('API_URL')+'/invoice/get_task_schedule/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
             params:{
                 frequency_id:frequency_id,
                 from:from,
                 to:to,
                 status:status,
                 userSubGroup: userSubGroup,
                 userGroup: userGroup
             }
        }).then(response => {
             var tdata =  [];
             if (Array.isArray(response.data.data) && response.data.data.length) {
                 tdata = response.data.data;

                 this.setState({
                     task_data: tdata,
                     loading:false
                 });
             } else {

             tdata = response.data.data;
                 this.setState({
                     task_data: tdata,
                     loading:false
                 })
             }
             $('#TaskTable').DataTable();

        }).catch( err => {
            console.log(err);
        });
    }

    startSchedule(id,e){
        e.preventDefault();
        confirmAlert({
            title: 'Question',
            message: 'Are you sure want to start task schedule.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickRerun(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }

    stop_process(e, rowData){
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'Are you sure, you want to stop this task',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickStopProcess(rowData.task_schedule_id, rowData.task_run_id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }
    handleClickStopProcess(id,rid){
        axios.get(config.get('API_URL')+'/invoice/stop_process_log_one/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                task_run_id:rid,
                email: this.state.email
            }
        }).then(response => {
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
        }).catch( err => {
            console.log(err);
        });
    }
    stopSchedule(id,e){
        e.preventDefault();
        confirmAlert({
            title: 'Question',
            message: 'Are you sure, you want to stop this task',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleStopSchedule(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }
    handleStopSchedule(id){
        axios.get(config.get('API_URL')+'/invoice/stop_process_log/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                email: this.state.email
            }
        }).then(response => {
            this.get_task_schedule(this.state.frequency_id, this.state.month_year,'','',this.state.userSubGroup, this.state.userGroup);
        }).catch( err => {
            console.log(err);
        });
    }
    get_process_log(frequency_id, from, to,status,userSubGroup,userGroup) {
        // const fields = month.split('_');
        // const monthval = fields[0];
        // const yearval = fields[1];
        var postData = {
            frequency_id:frequency_id,
            from: from,
            to:to,
            status:status,
            userSubGroup: userSubGroup,
            userGroup: userGroup
        }
        if ($.fn.DataTable.isDataTable('#logTable')) {
            $('#logTable').DataTable().clear().destroy();
        }
        var logTable = $('#logTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 10,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": true,
                //"dom": '<"top"lf>t<"bottom"pi><"clear">',
                "searching": true,
                //"lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/get_process_logs",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {  console.log(json.data);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data":"start_time"},
                    {"data":"process"},
                    {"data":"status"},
                    {"data":"task_start_date"},
                    {"data":"task_end_date"},
                    {"data":"run_time"},
                    {"data":"run_by"},
                    {"data":"error_msg"},
                    {"data":"arguments"},
                    {"data":"task_schedule_id"},
                ],
                "columnDefs": [
                    {
                        "targets": 2,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                        //console.log(td);
                            if (rowData.status == 'success') {
                                $(td).addClass('doneLog');
                            }
                            if (rowData.status == 'running') {
                                $(td).addClass('ongoingLog');
                            }
                            if (rowData.status == 'failed') {
                                $(td).addClass('failedLog');
                            }
                            if (rowData.status == 'stopped') {
                                $(td).addClass('stopedLog');
                            }
                        },
                    },
                    {

                        "className":"text-center",
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');

                            if(rowData.error_msg==null || rowData.error_msg=='null' || rowData.error_msg=='') {
                                $(td).text('');

                            }
                            else {
                                var n = rowData.error_msg.length;
                                if (n > 50) {
                                    var trimmedString = rowData.error_msg.substring(0, 50);
                                    $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View More..</a>');
                                    $(td).click(e => {
                                        this.toggleNewIssueModel(e, rowData.error_msg);
                                    })
                                } else {
                                    $(td).append(rowData.error_msg );

                                }
                            }
                        },
                        bSortable: false,
                    },
                    {
                        render: function (data, type, row) {

                            return '<td><a href="#" data-toggle="tooltip" title='+JSON.stringify(data)+'><i class="fa fa-info-circle" aria-hidden="true"></i></a></td>';

                        },

                        className: "",
                        targets: 8,
                        aTargets: [-1]
                    },
                    {
                    "width": "50px",
                     "className":"text-center",
                    "targets": 9,
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).text('');
                        if(rowData.status=='running') {
                            $(td).append('<a href="#"  data-tip="Stop" title="Stop" id="Stop"  class="stopButton" >Stop</a>');
                            $(td).click(e => {
                                this.stop_process(e,rowData);
                            })
                        }
                        else {
                            $(td).append('<a href="#"  data-tip="Re Run" title="Re Run" id="re_run"  class="RerunButton" >Rerun</a>');
                            $(td).click(e => {
                                this.re_run(e,rowData);
                            })
                        }
                    },
                    bSortable: false,
                }]

            });
    }
    re_run(e, rowData){
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'Are you sure, you want to re-run this task',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickRerun(rowData.task_schedule_id, rowData.task_run_id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }

    handleClickRerunTask(forceRun, run_type, e) {

        if (forceRun == 1) {
            forceRun = 1
        } else {
            forceRun = 0
        }
        // alert(forceRun)
        //alert(this.state.merchantID); alert(this.state.chainID); alert(this.state.storeID);
    //alert(this.state.arg_type);
        //$("#logTable_processing").css("display", "block");

        axios.post(config.get('API_URL')+'/invoice/rerun_process_log_task/',{
                arg_type: this.state.arg_type,
                task_schedule_id: this.state.feq_id,
                user_email: this.state.email,
                merchantID: this.state.merchantID,
                chainID: this.state.chainID,
                storeID: this.state.storeID,
                acqBankID: this.state.acq_bank_id,
                from:  this.state.yestSend1,
                to: this.state.todSend1,
                task_identifier: this.state.task_identifier,
                force_run: forceRun,
                run_type: run_type,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {
            // console.log(response);
            // console.log(response.data.extra_data.error)
            if (response.data.extra_data.error === 'failed-tasks') {
                var array = response.data.extra_data.tasks
                var ts = array.join(', ');
                //console.log(ts);
                this.setState({
                    force_run: 1,
                    etype: response.data.extra_data.error,
                    tasks_lists: ts
                })
                this.toggleNewErrorModel(response.data);
            }
            if(response.data.error){
                this.props.handleClick("tr", 3, response.data.error);
            }
            else {
                this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status, this.state.userSubGroup, this.state.userGroup);
                this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status, this.state.userSubGroup, this.state.userGroup);
            }


        }).catch( err => {
            console.log(err);
        });
        this.setState({
            newRiseModel: false
        })
    }

    handleClickRerun(id, rid){ //alert(id); alert(this.state.email);
        //$("#logTable_processing").css("display", "block");
        //alert(rid);
        axios.get(config.get('API_URL')+'/invoice/rerun_process_log/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                run_id: id,
                task_run_id: rid,
                email: this.state.email
            }
        }).then(response => {
            //console.log(response);
           // $("#logTable_processing").css("display", "none");
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);

        }).catch( err => {
            console.log(err);
        });
    }
    get_frequency(val){
        axios.get(config.get('API_URL')+'/invoice/get_frequency_name/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        //console.log(response);
            response.data.map((frequency,index) => {
                this.state.feq_name_list.push({value: frequency.task_frequency_id, label: frequency.frequency_name})
            });

        }).catch( err => {
            console.log(err);
        });
    }
    changeMonth(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        //alert(value);
        this.setState({
            month_year: value
        });


    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
            this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
            // this._get_filtered_eod_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.cardGradeIDs, this.state.schemeIDs, this.state.cardTypeIDs)
        }

    }





    changeMonth_task(event, picker, e) {
       //  const value = optionSelected === null ? '' : optionSelected.value;
       // // alert(value);
       //  this.setState({
       //      month_year_task: value
       //  });

        this.setState({
            todSend1: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend1: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow1: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow1: moment(picker.endDate).format('D MMM YYYY')
        });

    }
    changeFrequency(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            frequency_id: value
        });
        this.get_process_log(value, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
        this.get_task_schedule(value, this.state.yestSend, this.state.todSend,this.state.selected_status,this.state.userSubGroup, this.state.userGroup);
    }
    changeStatus(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
       // alert(value);
        this.setState({
            statusValue: optionSelected,
            selected_status: value
        });
        this.get_process_log(this.state.frequency_id, this.state.yestSend, this.state.todSend,value,this.state.userSubGroup, this.state.userGroup);
        this.get_task_schedule(this.state.frequency_id, this.state.yestSend, this.state.todSend,value,this.state.userSubGroup, this.state.userGroup);
    }
    onTypeChanged(e){
        this.setState({
            arg_type:e.target.value
        });
        if(e.target.value=='Acquiring_Bank'){
            this.setState({
                merchantID: [],
                chainID: []
            })
        }

        if(e.target.value=='Issuing_Bank'){
            this.setState({
                merchantID: [],
                chainID: []
            })
        }
    }
    changeBank(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            acq_bank_id: value
        })
    }

    run_all(e) {
        //.log(rowData.task_schedule_id);
        confirmAlert({
            title: 'Question',
            message: 'This will start all tasks which are applicable to run. Are you sure, you want to do this',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickRerunTask(1, 'automated')
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "34px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 }),

        };

        let taskTableData = this.state.task_data.map((val,index) => {
            return (
                <tr key={index + 1}>
                    <td>{val["task_name"]}</td>
                    <td>{val["comments"]}</td>
                    <td>{moment(val["last_system_run_start_time"]).format('D MMM YYYY HH:mm:ss')}</td>
                    <td>{val["last_run_status"]}</td>
                    <td className="text-center">
                        {/*<ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>*/}
                        <a href="#" onClick={this.toggleNewStartModel.bind(this, val.task_identifier, val.task_schedule_id)} data-tip="Start"   className="startButton">Start</a>
                    </td>
                    <td className="text-center">
                        {/*<ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>*/}
                        <a href="#" onClick={this.stopSchedule.bind(this, val.task_schedule_id)} data-tip="Stop"   className="stopButton">Stop</a>
                    </td>
                </tr>
            )
        });
        return(


            <div className="content">

                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <NotificationSystem ref="notificationSystem" style={style}/>
                                <div className="content">
                                    <div className="row">
                                        <NotificationSystem ref="notificationSystem" style={style} />
                                        <div className="col-md-12">
                                            <div className="col-md-3 ">
                                                <label> Frequency </label>
                                                <Select name="Frequency"
                                                        styles={customStyles} className="chainLists"
                                                        isClearable={false}
                                                        onChange={this.changeFrequency.bind(this)}
                                                        options={this.state.feq_name_list}
                                                        defaultValue={{ label: "Daily", value: 2 }}
                                                        placeholder="Frequency"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <label> Status </label>
                                                <Select name="status"
                                                        value={this.state.statusValue}
                                                        styles={customStyles} className="chainLists"
                                                        isClearable={false}
                                                        onChange={this.changeStatus.bind(this)}
                                                        options={this.state.statusList}
                                                        defaultValue={{ label: "All", value: '' }}
                                                        //placeholder="Status"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 ">

                                                <label> Date Filter </label>
                                                <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                                 onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>
                                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                                    <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                           value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                                </DateRangePicker>
                                                {/*<Select name="month"*/}
                                                {/*        styles={customStyles} className="chainLists"*/}
                                                {/*        isClearable={false}*/}
                                                {/*        onChange={this.changeMonth.bind(this)}*/}
                                                {/*        options={monthOptions}*/}
                                                {/*        defaultValue={monthOptions[12]}*/}
                                                {/*        placeholder="Months"*/}
                                                {/*/>*/}
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 pull-right top-margin-30">
                                                <Button color="primary run-all-task"
                                                        onClick={this.run_all.bind(this)}>Run
                                                    All</Button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <hr className="m-0 p-0"/>
                                <div className="content table-full-width table-responsive nomargin">

                                    <div className="header">
                                        <h4 className="title">Task Schedule</h4>
                                    </div>
                                    <table id="TaskTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>Script Name</th>
                                            <th>Comments</th>
                                            <th>Last system run start time</th>
                                            <th>Last Run Status</th>
                                            <th className="text-center">Start</th>
                                            <th className="text-center">Stop</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {taskTableData}
                                        </tbody>

                                    </table>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                    <hr/>
                                    <div className="header">
                                        <h4 className="title">Process Log</h4>
                                    </div>
                                    <table id="logTable" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Process</th>
                                            <th>Status</th>
                                            <th>Task Start Date</th>
                                            <th>Task End Date</th>
                                            <th>Run Time</th>
                                            <th>Run By</th>
                                            <th>Issues</th>
                                            <th>Arguments</th>
                                            <th className="text-center">Rerun</th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal isOpen={this.state.newRiseModel} toggle={this.toggleNewStartModel.bind(this)} >
                    <ModalHeader toggle={this.toggleNewStartModel.bind(this)}>Task Schedule</ModalHeader>
                    <ModalBody>
                        <div className="">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <input type="radio" name="arg_type" value="Merchant" checked={this.state.arg_type === 'Merchant'}
                                           onChange={this.onTypeChanged.bind(this)} /> Merchant &nbsp;&nbsp;&nbsp;
                                    <input type="radio" name="arg_type" value="Acquiring_Bank" checked={this.state.arg_type === 'Acquiring_Bank'}
                                           onChange={this.onTypeChanged.bind(this)} /> Acquiring Bank &nbsp;&nbsp;&nbsp;
                                    <input type="radio" name="arg_type" value="Issuing_Bank" checked={this.state.arg_type === 'Issuing_Bank'}
                                           onChange={this.onTypeChanged.bind(this)} /> Issuer Bank &nbsp;&nbsp;&nbsp;
                                </div>
                            </div>
                            {this.state.arg_type =='Merchant'?
                                <div>
                                    <div className="col-md-3">
                                        <label>Merchants</label>
                                        <Select name="merchants"
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="merchantLists"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this)}
                                                options={this.state.merchantList}
                                            // defaultValue={{ label: "All", value: '' }}
                                                placeholder="All"
                                        />

                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-3">
                                        <label> Chain </label>
                                        <Select name="chain"
                                                value={this.state.chainValue}
                                                styles={customStyles} className="chainLists"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this)}
                                                options={this.state.chainList}
                                            // defaultValue={{ label: "All", value: '' }}
                                                placeholder="All"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-3">
                                        <label> Store </label>
                                        <Select name="store"
                                                value={this.state.storeValue}
                                                styles={customStyles} className="chainLists"
                                                isClearable={false}
                                                onChange={this.changeStore.bind(this)}
                                                options={this.state.storeList}
                                            // defaultValue={{ label: "All", value: '' }}
                                                placeholder="All"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                </div> :null }

                            {this.state.arg_type =='Acquiring_Bank'?
                                <div>
                                    <div className="col-md-3">
                                        <label>Acquiring Banks</label>
                                        <Select name="acq_bank_id"
                                                styles={customStyles} className="chainLists"
                                                isClearable={false}
                                                onChange={this.changeBank.bind(this)}
                                                options={this.state.acq_bank_list}
                                            // defaultValue={{ label: "All", value: '' }}
                                                placeholder="All"
                                        />

                                        <div className="clearfix"></div>
                                    </div>

                                </div> :null }
                            {this.state.arg_type =='Issuing_Bank'?
                                <div>
                                    <div className="col-md-3">
                                        <label>Issuing Banks</label>
                                        <Select name="issuer"
                                                styles={customStyles} className="chainLists"
                                                components={{ MenuList }}
                                                isClearable={false}
                                                onChange={this.change_issuer.bind(this)}
                                                options={this.state.issuerBankList}
                                            // defaultValue={{ label: "All", value: '' }}
                                                placeholder="All"
                                        />

                                        <div className="clearfix"></div>
                                    </div>

                                </div> :null }

                            {/*<div className="clearfix"></div>*/}
                            {/*<div className="gap20"></div>*/}
                            <div className="col-md-3 audit-log" >
                                <label> Date Range </label>
                                {/*<Select name="month"*/}
                                {/*        styles={customStyles} className="chainLists"*/}
                                {/*        isClearable={false}*/}
                                {/*        onChange={this.changeMonth_task.bind(this)}*/}
                                {/*        options={monthOptions_task}*/}
                                {/*        defaultValue={monthOptions_task[0]}*/}
                                {/*        placeholder="Months"*/}
                                {/*/>*/}

                                <DateRangePicker startDate={this.state.datefrom1} endDate={this.state.dateTo1}
                                                 onEvent={this.changeMonth_task.bind(this)}  maxDate = {this.state.dateLimit}>
                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                    <input type="text" name="dateRange" className="form-control dateRangeInput"
                                           value={this.state.datefromShow1 + ' - ' + this.state.dateToShow1}/>
                                </DateRangePicker>
                                <div className="clearfix"></div>

                            </div>
                            <div className="clearfix"></div>

                            {/*<div className="content-tdetails-table table-full-width table-responsive">*/}
                            {/*    <table id="EmiSchemeTable" className="table table-striped table-hover">*/}

                            {/*    </table>*/}
                            {/*</div>*/}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary"
                                onClick={this.handleClickRerunTask.bind(this, 0, 'manual')}>Submit</Button>{' '}
                        <Button color="secondary" onClick={this.toggleNewStartModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                    <Modal isOpen={this.state.newIssueModel} toggle={this.toggleNewIssueModel.bind(this)} >
                        <ModalHeader toggle={this.toggleNewIssueModel.bind(this)}>Issue Details</ModalHeader>
                        <ModalBody>
                            <div className="issue_container">
                                {this.state.issue}
                            </div>
                        </ModalBody>
                        <ModalFooter>

                            <Button color="secondary" onClick={this.toggleNewIssueModel.bind(this)}>Cancel</Button>
                        </ModalFooter>
                    </Modal>

                    <ModalD visible={this.state.newErrorModel} width="300" height="100" effect="fadeInUp">
                        <div className="download-popup-model">
                            <div className="log-message-content">
                                {this.state.ts != '' ?
                                    <div>Tasks: {this.state.tasks_lists}</div> : null
                                }
                                {this.state.etype == 'failed-tasks' ?
                                    <React.Fragment>
                                        Force to run?
                                        <div className="col-md-12 pull-right">
                                            <a href="javascript:void(0);" onClick={() => this.closeModal()}
                                               className="log-btn-sure">
                                                No
                                            </a>
                                            <a href="javascript:void(0);" onClick={() => this.closeModalAndRun()}
                                               className="log-btn-sure">
                                                Yes
                                            </a>

                                        </div>
                                    </React.Fragment> : null}
                                {this.state.etype == 'running-tasks' ?
                                    <React.Fragment>
                                        Running
                                    </React.Fragment> : null}
                            </div>
                        </div>
                    </ModalD>
                </div>
            </div>
        );
    }
}

export default AuditLog